// istanbul ignore next
export const getChipDataTestId = (isActive: boolean) => `ChipButton${isActive ? '-Active' : ''}`;
